// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import iView from 'iview'
import VueI18n from 'vue-i18n'
import 'iview/dist/styles/iview.css'
import Constants from './common/Constants'
import RequestUtil from './utils/RequestUtil'
import Store from '@/store'
import 'whatwg-fetch';
import 'babel-polyfill'
import searchForm from "@/common/components/searchForm"
const searchFormItem = searchForm.Item
Vue.component('searchForm', searchForm)
Vue.component('searchFormItem', searchFormItem)

Vue.config.productionTip = false
Vue.prototype.Constants  = Constants
Vue.prototype.RequestUtil  = RequestUtil
Vue.prototype.$store = Store
Vue.use(VueI18n)
Vue.use(iView, {
  // iview组件国际化
  i18n (path, options) {
    let value = i18n.t(path, options)
    if (value !== null && value !== undefined) return value
    return ''
  }
})

const i18n = new VueI18n({
  locale: 'zh_CN', // 语言标识
  messages: {
    'ja_JP': require('./lang/ja-JP'),
    'zh_CN': require('./lang/zh-CN')
  }
})

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  router,
  i18n,
  Store,
  components: { App },
  template: '<App/>'
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js